import { useSelector } from 'react-redux';
import './TubeLink.css';

export default function TubeLink({ href, stateName, valueName,  className = '', ...props }) {
    const value = useSelector((state) => state[stateName][valueName]);
    return (
        <>
            {value && <a
                href={value}
                className={`tube-link ${className}`}
                target='_blank'
                rel='noreferrer'
                {...props}
            >
                {value}
            </a>}
        </>
    );
}